import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { QuestionChoice } from "./styled";
import { useTranslation } from "react-i18next";
import { getEnglishTranslation } from "../../utils/englishI18n";

const Label = styled.span`
    font-size: 30px;
`;

const HelpText = styled.span`
    font-size: 20px;
`;

const Spacer = () => <span> </span>;

const Choice = ({ choice: { label, helpText }, isSelected = false, onSelect = () => {}, onDeselect = () => {} }) => {
    const { t, i18n } = useTranslation();

    const onClick = useCallback(
        e => {
            e.preventDefault();
            // Store the English label value (for calculation lookups)
            const englishLabel = getEnglishTranslation(label, label, i18n);
            if (isSelected) {
                onDeselect(englishLabel);
            } else {
                onSelect(englishLabel);
            }
        },
        [label, i18n, isSelected, onSelect, onDeselect]
    );

    return (
        <QuestionChoice isSelected={isSelected} onClick={onClick}>
            <Label>{t(label, label)}</Label>
            <Spacer />
            <HelpText>{t(helpText, helpText)}</HelpText>
        </QuestionChoice>
    );
};

Choice.propTypes = {
    choice: PropTypes.object,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    onDeselect: PropTypes.func
};

export default Choice;
